<template>
  <div class="mb-15" style="overflow: hidden">
    <div class="row">
      <div class="col-md-12" style="overflow: hidden;">
        <div class="wrapper-preview-container shadow" v-bind:style="{ height: previewCardHeight + 'px' }">
          <div class="wrapper-preview" ref="previewCardWrapper" v-bind:style="{ transform: 'scale(' + previewCardScale + ')' }">
            <page-card-content
              ref="previewCard"
              :title="title"
              :message="message"
              :province="province"
              :school="school"
              :owner="owner"
              :previewSrc="previewSrc" />
          </div> <!-- /wrapper-preview -->

          <div class="form__file" v-if="editing">
              <div class="fas-wrapper">
                <i class="fas fa-camera"></i>
              </div>
            <input type="file" accept="image/*" @change="onSelectFile" ref="file" />
          </div>

          <div class="preview-edit">
            <a href="#" @click.prevent="edit" class="pull-right" v-if="showEditLink && !editMode">แก้ไข</a>
            <a href="#" @click.prevent="cancel" class="pull-right" v-if="showEditLink && editMode">ยกเลิก</a>
          </div>

        </div>
      </div>
      <div class="capture-image-wrapper" v-if="editing">
        <div class="capture-image" ref="captureCard">
          <page-card-content
                  ref="capturePageCard"
                  :title="title"
                  :message="message"
                  :province="province"
                  :school="school"
                  :owner="owner"
                  :previewSrc="previewSrc" />
        </div>

        <div class="capture-canvas" ref="captureCanvas">
          canvas here
        </div>

      </div>

    </div>
  </div>
</template>

<script>
  import html2canvas from 'html2canvas'
  import PageCardContent from '@/components/PageCardContent'

  const Pica = require('../../node_modules/pica/dist/pica.min')

  /**
   * @see: https://github.com/brion/min-wasm-fail/blob/master/min-wasm-fail.js
   * @see: https://support.scandit.com/hc/en-us/articles/115003947711-Known-issues-with-mobile-Safari-on-iOS-11-2-2-and-11-2-5
   */
  function testSafariWebAssemblyBug () {
    let bin = new Uint8Array([0, 97, 115, 109, 1, 0, 0, 0, 1, 6, 1, 96, 1, 127, 1, 127, 3, 2, 1, 0, 5, 3, 1, 0, 1, 7, 8, 1, 4, 116, 101, 115, 116, 0, 0, 10, 16, 1, 14, 0, 32, 0, 65, 1, 54, 2, 0, 32, 0, 40, 2, 0, 11])
    let mod = new window.WebAssembly.Module(bin)
    let inst = new window.WebAssembly.Instance(mod, {})

    // test storing to and loading from a non-zero location via a parameter.
    // Safari on iOS 11.2.5 returns 0 unexpectedly at non-zero locations
    return (inst.exports.test(4) !== 0)
  }

  let pica = null
  if (window.WebAssembly && testSafariWebAssemblyBug()) {
    pica = Pica({ features: [ 'js', 'wasm', 'ww', 'cib' ] })
  } else {
    pica = Pica({ features: [ 'js', 'cib', 'ww' ] })
  }

  const UPLOAD_RETRY_LIMIT = 3
  const UPLOAD_RETRY_WAIT = 2500
  const UPLOAD_MAX_SIZE = 2000000
  export default {
    name: 'PageCard',

    components: {
      PageCardContent
    },

    props: {
      message: {
        type: String,
        default: ''
      },
      title: {
        type: String,
        default: ''
      },
      province: {
        type: Object,
        default: null
      },
      school: {
        type: Object,
        default: null
      },
      image: {
        type: String,
        default: ''
      },
      owner: {
        type: String,
        default: ''
      },
      page: {
        type: Object,
        default: null
      },
      editing: {
        type: Boolean,
        default: false
      }
    },

    data () {
      var presetList = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10']
      this.shuffle(presetList)
      // TODO: user can select preset manually
      // console.log('this.form.page', this.page)
      return {
        file: null,
        previewSrc: this.image || '/static/img/image-preset-page/' + presetList[0] + '.jpg',
        imageSrc: '',
        editMode: false,
        imageData: null,
        previewCardScale: 1.0,
        previewCardHeight: 630
      }
    },

    computed: {
      showEditLink () {
        return this.$store.state.token && this.page && this.$store.state.user && this.$store.state.user.uuid === this.page.member_id
      }
    },

    created () {
      this.editMode = this.editing

      this.handleResize()
      window.addEventListener('resize', this.handleResize)

      this.preloadImage()
    },
    beforeDestroy: function () {
      window.removeEventListener('resize', this.handleResize)
    },
    methods: {
      preloadImage () {
        this.imageSrc = this.previewSrc

        if (this.previewSrc.startsWith('http')) {
          const canvas = document.createElement('canvas')
          document.body.appendChild(canvas)
          const ctx = canvas.getContext('2d')
          const im = new window.Image()
          im.setAttribute('crossOrigin', 'anonymous')
          im.onload = () => {
            ctx.canvas.width = im.width
            ctx.canvas.height = im.height
            ctx.drawImage(im, 0, 0)
            this.previewSrc = canvas.toDataURL()
            canvas.parentNode.removeChild(canvas)
          }
          im.src = this.previewSrc
        }
      },

      shuffle (a) {
        var j, x, i
        for (i = a.length - 1; i > 0; i--) {
          j = Math.floor(Math.random() * (i + 1))
          x = a[i]
          a[i] = a[j]
          a[j] = x
        }
      },
      handleResize (event) {
        var ratio = 0.75
        var scale = 1
        var padding = 12
        if (window.innerWidth <= 767) {
          padding = 0
          scale = ((ratio * (window.innerWidth - (padding))) / 630.0)
        } else if (window.innerWidth <= 991) {
          scale = ((ratio * (window.innerWidth - (padding + 15 + 15))) / 630.0)
        } else if (window.innerWidth <= 1199) {
          scale = 0.72
        } else {
          scale = 0.88
        }
        this.previewCardScale = scale
        this.previewCardHeight = Math.floor(630.0 * scale + padding)
      },

      onSelectFile (event) {
        const files = event.target.files
        if (!files || files.length === 0) {
          return
        }
        this.file = files[0]

        if (!this.file.type.startsWith('image/')) {
          this.file = null
          this.$refs.file.value = ''
          this.$modal.show({
            title: 'เกิดข้อผิดพลาด',
            text: 'อัพโหลดได้เฉพาะไฟล์รูปภาพเท่านั้น'
          })
          return
        }

        if (this.file.size > UPLOAD_MAX_SIZE) {
          this.value = ''
          this.$modal.show({
            title: 'เกิดข้อผิดพลาด',
            text: 'ขนากไฟล์ใหญ่เกินไป ไฟล์จะต้องไม่เกิน ' + window.Math.floor(UPLOAD_MAX_SIZE / 1000000) + 'MB'
          })
          return
        };

        const reader = new window.FileReader()
        reader.addEventListener('load', (e) => {
          this.previewSrc = reader.result
          this.$emit('select-file', this.file, reader.result)
        }, false)
        reader.readAsDataURL(this.file)
      },
      captureCanvasToS3 () {
        // Sync image
        let result = {}
        let aclPublic = true
        let promise1 = null
        if (this.file) {
          promise1 = this.$http.get('storage/presigned-url', {params: {mimetype: this.file.type, prefix: 'page', public: aclPublic}})
            .then(resp => {
              const presignedUrl = resp.body.presignedUrl
              const viewUrl = resp.body.url
              this.uploadToS3(this.file, this.file.type, presignedUrl, viewUrl, aclPublic)
              result.image = viewUrl
              return Promise.resolve()
            })
        } else {
          result.image = this.imageSrc
          promise1 = Promise.resolve()
        }

        // Sync share image
        let promise2 = new Promise((resolve) => {
          this.$refs.capturePageCard.capture()
          let mimetype = 'image/jpeg'
          html2canvas(this.$refs.captureCard, {scale: 1})
            .then(canvas => {
              console.log('canvas', canvas.width, canvas.height)
              // this.$el.$ref.captureCanvas.appendChild(canvas)
              return pica.toBlob(canvas, mimetype)
            })
            .then(blob => {
              let file = null
              try {
                file = new window.File([blob], '', { type: mimetype })
              } catch (e) {
                file = new window.Blob([blob], { type: mimetype })
              }

              this.$http.get('storage/presigned-url', { params: { mimetype: mimetype, prefix: 'page-cover', public: aclPublic } })
                .then(resp => {
                  const presignedUrl = resp.body.presignedUrl
                  const viewUrl = resp.body.url
                  this.uploadToS3(file, file.type, presignedUrl, viewUrl, aclPublic)
                  result.shareImage = viewUrl
                  resolve()
                })
            })
        })
        return Promise.all([promise1, promise2]).then(() => {
          return result
        })
      },
      uploadToS3 (file, mimetype, presignedUrl, viewUrl, aclPublic) {
        let retryLimit = UPLOAD_RETRY_LIMIT

        let startUpload = () => {
          retryLimit--

          const oReq = new window.XMLHttpRequest()
          oReq.addEventListener('load', ev => {
            if (ev.target.status === 200) {
              this.$emit('uploaded', viewUrl.replace(/\?.*/, ''))
            } else {
              if (retryLimit > 0) {
                setTimeout(() => {
                  startUpload()
                }, UPLOAD_RETRY_WAIT)
              } else {
                // this.errorHandler(oReq) # crosalot said unnecessary
              }
            }
          })
          oReq.addEventListener('error', ev => {
            if (retryLimit > 0) {
              setTimeout(() => {
                startUpload()
              }, UPLOAD_RETRY_WAIT)
            } else {
              // this.errorHandler(oReq) # crosalot said unnecessary
            }
          })

          oReq.open('PUT', presignedUrl, true)
          oReq.setRequestHeader('Content-Type', mimetype)
          if (aclPublic) {
            oReq.setRequestHeader('X-Amz-Acl', 'public-read')
          }
          oReq.send(file)
        }

        startUpload()
      },
      edit () {
        this.editMode = true
        this.$emit('edit')
      },

      cancel () {
        this.editMode = false
        this.$emit('cancel')
      }
    }
  }
</script>

<style lang="scss" scoped>
  .capture-image-wrapper {
    width: 0;
    height: 0;
    overflow: hidden;
  }
  .capture-image {
    overflow: hidden;
    height: 630px;
    width: 1200px;
  }

  .wrapper-preview-container {
    position: relative;
    padding: 6px;
    background-color: #fff;

    .preview-edit {
      .pull-right {
        font-size: 0.75em;
        position: absolute;
        top: 10px;
        right: 10px;
        padding: 2px 6px;
        background: #fff;
        border-radius: 5px;
      }
    }
  }

  .wrapper-preview {
    width: 840px;
    overflow: hidden;
    transform-origin: top left;

    .page-card-content {
      margin-left: -180px;
    }
  }

  .form__file, .form__file input, .form__file .fas {
    position: absolute;
    top: 0;
    left: 0;
  }
  .form__file {
    width: 100%;
    height: 60%;
  }
  .form__file input {
    opacity: 0;
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
  .form__file .fas-wrapper {
    font-size: 2em;
    color: #fff;
    margin: 15px;
  }

  @media screen and (max-width: 767px) {
    .wrapper-preview-container {
      padding: 0;
      box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.75);
      background-color: transparent;
    }
    .row { margin-right: 0; }
  }

  .capture-image {
    z-index: 999;
    font-size: 1.5em;
    line-height: 1.5;

    /deep/ .page-card-container {
      width: 1000px !important;
    }
  }

</style>



// WEBPACK FOOTER //
// PageCard.vue?5a331ada